import React, { useState, useEffect } from "react";
import { X } from "lucide-react";

const MobileNotice: React.FC = () => {
  const [showNotice, setShowNotice] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);

      // Only show if mobile and hasn't been dismissed before
      if (mobile && !localStorage.getItem("mobileNoticeDismissed")) {
        setShowNotice(true);
      }
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const handleDismiss = () => {
    setShowNotice(false);
    localStorage.setItem("mobileNoticeDismissed", "true");
  };

  if (!isMobile || !showNotice) return null;

  return (
    <div className="mobile-notice-overlay" onClick={handleDismiss}>
      <div className="mobile-notice-modal" onClick={(e) => e.stopPropagation()}>
        <button className="mobile-notice-close" onClick={handleDismiss}>
          <X size={20} />
        </button>
        <div className="mobile-notice-content">
          <p>This website looks cooler on a computer</p>
        </div>
      </div>
    </div>
  );
};

export default MobileNotice;
